import { faSearch } from '@fortawesome/pro-solid-svg-icons'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { FeatureFlags } from '@/helpers/featureFlags'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

import { useListingSearch } from '../search/ListingSearchProvider'
import { getAppliedThreshold } from '../search/ListingSearchProvider/categoryThreshold'

const MIN_THRESHOLD = 5

/**
 * Empty-state props offering to lower the category threshold to the minimum,
 * or null when no applied threshold sits above it. Shared by the grid and
 * list views so both render the same escape hatch on zero results.
 */
export const useThresholdEmptyState = () => {
  const { state, updateFilters, rankingSurface } = useListingSearch()
  const { track } = useAnalytics()
  const enableCategoryThreshold = useFlag(
    FeatureFlags.ENABLE_CATEGORY_COMPOSITION_THRESHOLD
  )

  const appliedThreshold = getAppliedThreshold(state.filters)
  if (
    !enableCategoryThreshold ||
    appliedThreshold === null ||
    appliedThreshold <= MIN_THRESHOLD
  ) {
    return null
  }

  return {
    icon: faSearch,
    title: <FormattedMessage id="Listing.noResults.threshold.title" />,
    description: (
      <FormattedMessage id="Listing.noResults.threshold.description" />
    ),
    primaryButton: {
      label: <FormattedMessage id="Listing.noResults.threshold.cta" />,
      handleClick: () => {
        track('category_threshold_min_reset', {
          previous_threshold: appliedThreshold,
          surface: rankingSurface === 'storefront' ? 'storefront' : 'alp',
        })
        updateFilters({ categoryThreshold: MIN_THRESHOLD })
      },
    },
  }
}
